module.exports = __webpack_public_path__ + "static/media/grey-chevron.e587e12b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/grey-chevron.svg
 ** module id = 1277
 ** module chunks = 0
 **/